import React__default, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ArrowRightIcon = forwardRef((props, ref) => {
    return (React__default.createElement(SvgIcon, Object.assign({}, props, { ref: ref }),
        React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17.914", height: "11.973", viewBox: "0 0 17.914 11.973" },
            React__default.createElement("g", { id: "Arrow", transform: "translate(0.001)" },
                React__default.createElement("g", { id: "Group_222", "data-name": "Group 222", transform: "translate(-0.001)" },
                    React__default.createElement("path", { id: "Path_232", "data-name": "Path 232", fill: "currentColor", d: "M22.631,137.3h0l-5.045-5.021a.966.966,0,0,0-1.362,1.369l3.388,3.371H5.966a.966.966,0,0,0,0,1.931H19.61l-3.387,3.371a.966.966,0,0,0,1.362,1.369l5.045-5.021h0A.966.966,0,0,0,22.631,137.3Z", transform: "translate(-5 -132)" }))))));
});

export { ArrowRightIcon };
//# sourceMappingURL=ArrowRightIcon.js.map
